import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getBodyStyle, getColor, Theme } from 'styles/theme';

export const PackageWrapper = styled.div`
  padding: 0 20px 24px;

  @media (${breakpoint.mdMin}) {
    padding: 0 0  24px;
  }
`;

export const Description = styled.p<{ theme: Theme }>`
   ${getBodyStyle('graphikCond', { default: 'default' })};
    font-size: 16px;
    padding: 24px 0 0;
  
    > a {
      font-weight: bold;
      color: ${getColor('accentPrimary')};
    }
    
    @media (${breakpoint.mdMin}) {
      font-size: 20px;
    }
`;

export const PackageContent = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;

  @media (${breakpoint.mdMin}) {
    flex-direction: row;
  }

  .articles-carousel {
    width: 100%;
    padding-left: 20px;
    .card-eyebrow {
      margin-bottom: 12px;   
    }
    .article-card {
      gap:12px;
    }

    @media (${breakpoint.mdMin}) {
      width: 75%;
      padding-left: 0;
      border-bottom: 1px solid ${getColor('borderSecondary')};
      &.full-width {
        width: 100%; 
      }
    }
  }
`;

export const PackageImage = styled.div`
  width: 100%;
  padding: 0 20px;
  position: relative;

  @media (${breakpoint.mdMax}) {
    margin-bottom: 20px;
    
    &:before {
      content: '';
      background: linear-gradient(180deg, rgba(17, 17, 17, 0.10) 0%, rgba(17, 17, 17, 0.00) 100%);
      height: 50px;
      width: 100%;
      position: absolute;
      bottom: -70px;
      left: 0;
    }
  }

  @media (${breakpoint.mdMin}) {
    width: 25%;
    padding: 0 24px 0 0;
  }
  
`;
